import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "./components/site/Navbar";
import { Hero } from "./components/site/Hero";
import { Manifesto } from "./components/site/Manifesto";
import { StatesGrid } from "./components/site/StatesGrid";
import { Travellers } from "./components/site/Travellers";
import { Festivals } from "./components/site/Festivals";
import { PlanTrip } from "./components/site/PlanTrip";
import { Footer } from "./components/site/Footer";
import { useReveal } from "./hooks/useReveal";
import Journeys from "./pages/Journeys";
import JourneyDetail from "./pages/JourneyDetail";
import State from "./pages/State";

const Home = () => {
    useReveal();
    const location = useLocation();

    useEffect(() => {
        document.title = "enei.in — Letters from the Northeast";
    }, []);

    // Honour #section anchors when navigating in from another route
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
        }
    }, [location]);

    return (
        <div className="App grain">
            <Navbar />
            <main>
                <Hero />
                <Manifesto />
                <StatesGrid />
                <Travellers />
                <Festivals />
                <PlanTrip />
            </main>
            <Footer />
        </div>
    );
};

const ScrollToTop = () => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 400);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    if (!visible) return null;
    return (
        <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Scroll to top"
            style={{
                position: "fixed",
                bottom: "100px",
                right: "20px",
                zIndex: 9998,
                background: "#1A2C22",
                color: "#F4F2EC",
                border: "none",
                borderRadius: "50%",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 2px 12px rgba(0,0,0,0.25)",
                fontSize: "18px",
                transition: "opacity 0.3s, transform 0.3s",
            }}
        >
            ↑
        </button>
    );
};

const WhatsAppFloat = () => (
    <a
        href="https://wa.me/917002345186"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 9999,
            background: "#25D366",
            borderRadius: "50%",
            width: "52px",
            height: "52px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 20px rgba(37,211,102,0.4)",
            animation: "wa-pulse 2.5s infinite",
        }}
    >
        <svg viewBox="0 0 24 24" fill="white" width="28" height="28">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
    </a>
);

function App() {
    return (
        <BrowserRouter>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#1A2C22",
                        color: "#F4F2EC",
                        border: "1px solid rgba(244,242,236,0.15)",
                        borderRadius: 0,
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
            <WhatsAppFloat />
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/journeys" element={<Journeys />} />
                <Route path="/journeys/:slug" element={<JourneyDetail />} />
                <Route path="/states/:slug" element={<State />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
